import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Row, Col, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { StepsPage } from '../structure'
import { Uploader } from '@/components'
import { useUploadProcess } from '../context/UploadProcessProvider'
import { LinkWithPicture, ListItems } from '../components/common/'
const { Title, Paragraph } = Typography

const STEP_NUMBER = 0

const Upload = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data, setValues, uploadFile } = useUploadProcess()

  useEffect(() => {
    if (data.id && data.submission_id) {
      navigate(`${data.submission_id}/${data.id}`)
    }
  }, [data.id])

  const handleUpload = (params) => {
    uploadFile(params.file, (result) => {
      setValues({
        file: result,
        title: result.file_name,
        id: result._id,
      })
    })
  }
  return (
    <StepsPage
      step={STEP_NUMBER}
      className="upload-step1"
      title={t('Upload.UploadYourText')}
    >
      <Uploader onUpload={handleUpload} />
      <LinkWithPicture text={t('Upload.GoodToKnow')} content={<GoodToKnow />} />
    </StepsPage>
  )
}

const GoodToKnow = () => {
  const { t } = useTranslation()

  return (
    <Row gutter={{ sm: 0, xl: 90 }}>
      <Col span={24}>
        <Title>{t('Upload.PublishingWithGRIN')}</Title>
        <br />
      </Col>
      <Col className="what-text" xs={24} sm={14} xl={12}>
        <Title level={3}>{t('Upload.WhatTexts')}</Title>
        <Paragraph>{t('Upload.TextSort1')}</Paragraph>
        <ListItems namePrefix={'Upload.TextSort'} size={7} startPosition={2} />
      </Col>
      <Col xs={24} sm={14} xl={12}>
        <Title level={3}>{t('Upload.WhatTextsNot')}</Title>
        <ListItems
          namePrefix={'Upload.TextSort'}
          size={6}
          startPosition={9}
          type="disadvantage"
          style={{ marginBottom: '30px' }}
        />
        <Title level={3}>{t('Upload.WherePublished')}</Title>
        <Paragraph>{t('Upload.DistributionChannels')}</Paragraph>
      </Col>
    </Row>
  )
}
export default Upload
